import BaseFormPresenter from "../../base/BaseFormPresenter";

class ApplicationStatusPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
  // onChangePersonal(value, field) {
  //   this.personal[field] = value;
  //   const isAddressSame = this.view.state.isAddressSame;
  // }

  syncAddress() {
    this.personal["present_houseNumber"] =
      this.personal["permanent_houseNumber"] || "";
    this.personal["present_street"] = this.personal["permanent_street"] || "";
    this.personal["present_subdivision"] =
      this.personal["permanent_subdivision"] || "";
    this.personal["present_barangay"] =
      this.personal["permanent_barangay"] || "";
    this.personal["present_city"] = this.personal["permanent_city"] || "";
    this.personal["present_province"] =
      this.personal["permanent_province"] || "";
    this.personal["present_zipCode"] = this.personal["permanent_zipCode"] || "";
    this.personal["present_telephone"] = this.personal["telephone"] || "";
  }
  onChangePersonal(value, field) {
    this.personal[field] = value;

    const { isAddressSame } = this.view.state;

    if (isAddressSame) {
      this.syncAddress();
    }
  }
}

export default ApplicationStatusPresenter;
